export default class Mandate {
    createdAt: Date;
    mandateId: string;
    originatorName: string;
    payerName: string;
    reference: string;
    serviceUserNumber: string;
    state: string;
    walletId: string;
}